// src/plugins/validations.js
import { defineRule, configure } from 'vee-validate'
import { required, email, numeric, min_value, max_value } from '@vee-validate/rules'
import dayjs from 'dayjs'

// ---- Regras base (v4) ----
defineRule('required', required)
defineRule('email', email)
defineRule('numeric', numeric)
defineRule('min_value', min_value)
defineRule('max_value', max_value)

// ---- Regras custom ----
defineRule('isValidWorker', (value) => {
  if (value == null || value === '') return true // deixa 'required' tratar vazio
  return !String(value).includes('new') || 'Campo inválido'
})

defineRule('between_hour', (value) => {
  if (value == null || value === '') return true
  const n = Number(value)
  return (n >= 0 && n <= 23) || 'Hora tem de estar entre 0 e 23'
})

defineRule('between_minute', (value) => {
  if (value == null || value === '') return true
  const n = Number(value)
  return (n >= 0 && n <= 59) || 'Minutos têm de estar entre 0 e 59'
})

defineRule('password', (value, [target]) => {
  // confirmação de password (value === target)
  if (value == null || value === '') return true
  return value === target || 'Confirmação de password diferente'
})

defineRule('date_min', (value, [target]) => {
  if (!value || !target) return true
  // espera formato DD/MM/YYYY como no teu código
  const toISO = (d) => {
    const [dd, mm, yyyy] = String(d).split('/')
    return `${yyyy}-${mm}-${dd}`
  }
  const v = dayjs(toISO(value))
  const t = dayjs(toISO(target))
  return (v.isSame(t) || v.isAfter(t)) || `A data tem de ser maior ou igual a ${target}!`
})

defineRule('password_size', (value) => {
  if (value == null) return true
  return String(value).length >= 9 || 'Por favor insira pelo menos 9 carateres'
})

defineRule('special_char_1', (value) => {
  if (!value) return true
  return /[^A-Za-z0-9]/.test(value) || 'Por favor insira 1 carater especial'
})

defineRule('capital_letter', (value) => {
  if (!value) return true
  return /[A-Z]/.test(value) || 'Por favor insira pelo menos 1 carater maiúsculo'
})

defineRule('small_letter', (value) => {
  if (!value) return true
  return /[a-z]/.test(value) || 'Por favor insira pelo menos 1 carater minúsculo'
})

defineRule('one_number', (value) => {
  if (!value) return true
  return /\d/.test(value) || 'Por favor insira pelo menos 1 número'
})

// ---- Mensagens por defeito ----
configure({
  generateMessage: (ctx) => {
    const names = {
      required: '{field} é obrigatório',
      email: '{field} deve ser um email válido',
      numeric: '{field} deve ser numérico',
      min_value: '{field} deve ser maior ou igual a {min}',
      max_value: '{field} deve ser menor ou igual a {max}',
    }
    const rule = ctx.rule?.name
    if (names[rule]) {
      // parâmetros conhecidos (min/max) vêm em ctx.rule.params
      const params = ctx.rule?.params || []
      return names[rule]
        .replace('{field}', ctx.field)
        .replace('{min}', params[0] ?? '')
        .replace('{max}', params[0] ?? '')
    }
    // mensagens das regras custom já vêm da própria regra (string), por isso:
    return `{field} é inválido`
  },
})
